var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0003 18.3337C14.6027 18.3337 18.3337 14.6027 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 14.6027 5.39795 18.3337 10.0003 18.3337Z",
    fill: "#D77910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 9.37533H10.6253V6.66699C10.6253 6.32533 10.342 6.04199 10.0003 6.04199C9.65866 6.04199 9.37533 6.32533 9.37533 6.66699V9.37533H6.66699C6.32533 9.37533 6.04199 9.65866 6.04199 10.0003C6.04199 10.342 6.32533 10.6253 6.66699 10.6253H9.37533V13.3337C9.37533 13.6753 9.65866 13.9587 10.0003 13.9587C10.342 13.9587 10.6253 13.6753 10.6253 13.3337V10.6253H13.3337C13.6753 10.6253 13.9587 10.342 13.9587 10.0003C13.9587 9.65866 13.6753 9.37533 13.3337 9.37533Z",
    fill: "#D77910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.41ede5ae01408556e701dbe8ef470d9c.svg";
export { ForwardRef as ReactComponent };